import { useState } from 'react';
import { rsme } from '../lib/rsme';
import { useQuery } from '../ui/useQuery';
import { PageHead, Card, Input, Loading, ErrorState, EmptyState } from '../ui/primitives';

export default function Customers() {
  const [search, setSearch] = useState('');
  const q = useQuery(() => rsme.customers.list({ search, limit: 100 }), [search]);

  return (
    <div className="max-w-5xl mx-auto">
      <PageHead title="Customers" sub="Companies and their primary contact" />
      <div className="px-5 md:px-8">
        <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search company, code, phone, email" className="md:max-w-sm" />
      </div>

      <div className="px-5 md:px-8 mt-4 space-y-2">
        {q.loading && <Loading rows={6} />}
        {q.error && <ErrorState error={q.error} retry={q.refetch} />}
        {!q.loading && !q.error && !q.data?.data?.length && <EmptyState title="No customers" />}
        {q.data?.data?.map((c) => (
          <Card key={c.id} className="!p-4">
            <div className="flex items-start gap-3 flex-wrap">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2"><span className="font-medium truncate">{c.companyName}</span>{c.clientCode && <span className="text-xs text-muted tabular-nums">{c.clientCode}</span>}</div>
                <div className="text-xs text-muted mt-0.5 truncate">{c.contactPerson ?? '—'} · {c.phone ?? '—'} · {c.email ?? '—'}</div>
                {c.address && <div className="text-xs text-muted mt-0.5 truncate">{c.address}</div>}
              </div>
              {c.billingEntity && <span className="text-xs text-muted">{c.billingEntity}</span>}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
